"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const Item = /*#__PURE__*/_react.default.forwardRef((_ref, ref) => {
  let {
    children,
    value
  } = _ref;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("option", {
    value: value,
    ref: ref,
    children: children
  });
});
Item.displayName = 'Item';
var _default = exports.default = Item;
Item.propTypes = {
  children: _propTypes.default.string.isRequired,
  /**
   * The value of the option
   */
  value: _propTypes.default.string.isRequired
};